.speedbump {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  top: 0;
  left: 0;
  animation: speedbumpIn 250ms linear forwards;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(41, 134, 214, 0.7);
  }

  &__inner {
    position: absolute;
    width: 90%;
    max-width: 750px;
    background: #fff;
    padding: 30px;

    .warning-heading { font-weight: 700; }

    .title-heading {
      font-weight: 700;
      @include text-size(32);
      @include line-height(40);
    }
  }

  &__actions {
    display: flex;

    a {
      margin-right: 20px;
    }
  }

  @include media-breakpoint-down(sm) {
    &__inner {
      display: flex;
      flex-direction: column;
      align-items: center;

      .warning-heading {
        margin-bottom: 13px;
      }
     
      .title-heading { 
        text-align: center;
        margin-bottom: 16px;
      }

      .speedbump__message {
        text-align: center;
      }
    }
    
    &__actions {
      flex-direction: column;
      align-items: center;
      width: 100%;

      a {
        margin: 0 0 24px 0;

        &.btn.btn-primary { 
          margin-top: 10px; 
          width: 100%; 
        }
      }
    }
  }
}

@keyframes speedbumpIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
